import * as echarts from "echarts";
import { pdfFontsVfs } from "./kanit-pdf-vfs";

const KANIT_FONT_FACE_STYLE =
  `<style>@font-face{font-family:'Kanit';font-weight:normal;` +
  `src:url(data:font/ttf;base64,${pdfFontsVfs["Kanit-Regular.ttf"]}) format('truetype');}` +
  `@font-face{font-family:'Kanit';font-weight:bold;` +
  `src:url(data:font/ttf;base64,${pdfFontsVfs["Kanit-Bold.ttf"]}) format('truetype');}</style>`;

const decodeSvgDataUrl = (dataUrl) => {
  const commaIdx = dataUrl.indexOf(",");
   // ส่วนหลัง "data:"
  const meta = dataUrl.slice(5, commaIdx);
  const payload = dataUrl.slice(commaIdx + 1);
  return meta.includes("base64") ? decodeURIComponent(escape(atob(payload))) : decodeURIComponent(payload);
};

const encodeSvgDataUrl = (svgMarkup) => `data:image/svg+xml;base64,${btoa(unescape(encodeURIComponent(svgMarkup)))}`;

const embedKanitFontInSvg = (svgDataUrl) => {
  try {
    const svgMarkup = decodeSvgDataUrl(svgDataUrl).replace(/<svg[^>]*>/, (openTag) => `${openTag}${KANIT_FONT_FACE_STYLE}`);
    return encodeSvgDataUrl(svgMarkup);
  } catch (_) {
    return svgDataUrl;
  }
};

const svgDataUrlToPngDataUrl = (svgDataUrl, pixelRatio = 2) =>
  new Promise((resolve) => {
    const img = new Image();
    img.onload = () => {
      const canvas = document.createElement("canvas");
      canvas.width = (img.naturalWidth || img.width) * pixelRatio;
      canvas.height = (img.naturalHeight || img.height) * pixelRatio;
      const ctx = canvas.getContext("2d");
      ctx.fillStyle = "#fff";
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
      resolve(canvas.toDataURL("image/png"));
    };
    img.onerror = () => resolve(null);
    img.src = embedKanitFontInSvg(svgDataUrl);
  });


export const getChartImageDataUrl = async (el) => {
  if (!el) return null;

  const canvas = el.tagName === "CANVAS" ? el : el.querySelector("canvas");
  if (canvas) {
    try {
      return canvas.toDataURL("image/png", 1.0);
    } catch (_) {
      return null;
    }
  }

  const instance = echarts.getInstanceByDom(el);
  if (!instance) return null;
  try {
    const url = instance.getDataURL({ type: "png", pixelRatio: 2, backgroundColor: "#fff" });
    if (url && url.indexOf("data:image/svg+xml") === 0) {
      return await svgDataUrlToPngDataUrl(url, 2);
    }
    return url;
  } catch (_) {
    return null;
  }
};
